import React, { useState } from 'react';
import { Upload, Edit2, X } from 'lucide-react';

export const BaseEditProfile = ({ 
  children, 
  loading,
  error,
  bannerPreview,
  onBannerChange,
  onSave,
  onCancel,
  title = "Editar Perfil"
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-yellow-50 pt-8 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Banner Section */}
        <div className="relative h-64 mb-8 rounded-xl overflow-hidden shadow-lg">
          <img 
            src={bannerPreview || '/default-banner.jpg'} 
            alt="Banner" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/40"></div>
          
          {/* Banner Upload Button */}
          <label className="absolute top-4 right-4 bg-white/90 text-yellow-600 px-4 py-2 rounded-lg 
                         flex items-center gap-2 hover:bg-yellow-50 transition-all duration-300 cursor-pointer
                         shadow-lg hover:shadow-xl transform hover:scale-105">
            <Upload className="w-4 h-4" />
            Cambiar Banner
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={onBannerChange}
            />
          </label>
        </div>

        {/* Content */}
        <div className="space-y-8">
          {/* Title */}
          <div className="text-center">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-yellow-600 to-amber-500 bg-clip-text text-transparent">
              {title}
            </h1>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 p-4 rounded-xl shadow-sm">
              <div className="flex items-center gap-2">
                <X className="w-5 h-5" />
                <p className="font-medium">{error}</p>
              </div>
            </div>
          )}

          {children}

          {/* Action Buttons */}
          <div className="flex justify-end gap-4 mt-8">
            <button
              onClick={onCancel}
              className="px-6 py-3 border-2 border-yellow-200 text-yellow-700 rounded-xl
                       hover:bg-yellow-50 transition-all duration-300 transform hover:scale-105"
            >
              Cancelar
            </button>
            <button
              onClick={onSave}
              disabled={loading}
              className={`px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-500 text-white rounded-xl
                       shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105
                       ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const EditSection = ({ title, children }) => (
  <div className="bg-white rounded-xl shadow-lg p-8 border border-yellow-100/50">
    <div className="flex items-center gap-3 mb-6">
      <div className="h-8 w-1 bg-gradient-to-b from-yellow-500 to-amber-500 rounded-full" />
      <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
    </div>
    {children}
  </div>
);

export const EditProfileImage = ({ src, onChange }) => (
  <div className="relative group">
    <div className="w-40 h-40 rounded-full overflow-hidden shadow-lg border-4 border-white">
      <img 
        src={src || '/default-profile.jpg'} 
        alt="Profile" 
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-black/30 opacity-0 
                    group-hover:opacity-100 transition-all duration-300 
                    flex items-center justify-center">
        <label className="cursor-pointer transform transition-transform duration-300 
                       group-hover:scale-110">
          <div className="bg-white/90 p-3 rounded-full">
            <Edit2 className="w-6 h-6 text-yellow-600" />
          </div>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={onChange}
          />
        </label>
      </div>
    </div>
  </div>
);

export default BaseEditProfile;